export type Parameters = Record<string, string | number | null>

const serializeParameters = (params?: Parameters): string => {
  const normalizedParams: Record<string, string> = {}

  Object.entries(params ?? {}).forEach(
    ([key, value]) =>
      (normalizedParams[key] =
        value == null
          ? ''
          : typeof value === 'number'
          ? value.toString()
          : value)
  )

  return new URLSearchParams(normalizedParams).toString()
}

export default serializeParameters
